import { Box } from '@jfs/ui-new'
import { isEmpty } from '@jfs/utils'
import { Entity } from './Entity'

const { REACT_APP_ENDPOINT = '' } = window?._env_

export const Anchor = ({ type, label, hover, hrefPath, setHover, handlePress }: any) => {
  const value = type === 'link' ? label.toString() : `#${label.toString()}`

  const hyperlink = {
    color: '#214796',
    textDecoration: hover ? 'underline' : 'none',
    fontSize: '12px',
    fontFamily: 'jiotype-medium',
  }
  return (
    <Box onPress={() => {}} onHover={setHover} underlayColor={'TRANSPARENT'}>
      {!isEmpty(label?.toString() ?? '') && !isEmpty(hrefPath) && (
        <a
          href={`${window.location.origin}${REACT_APP_ENDPOINT}/${hrefPath}?id=${label}`}
          rel="noopener noreferrer"
          style={hyperlink}
          onContextMenu={() => localStorage.setItem('params', label)}
          onClick={() => localStorage.setItem('params', label)}>
          {value}
        </a>
      )}
      {isEmpty(hrefPath) && (
        <Entity type={type} label={label} setHover={setHover} handlePress={handlePress} hover={hover} />
      )}
    </Box>
  )
}
